if (!customElements.get('vt-lazy-video')) {
  class VtLazyVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    this.sources = this.video.querySelectorAll('source[data-src]');
    this.loaded = false;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.loadSources();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadSources();
            this.observer?.disconnect();
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        });
      },
      { rootMargin: '0px 0px', threshold: 0.5 }
    );

    this.observer.observe(this);
    document.addEventListener('shopify:section:load', this.onSectionLoad);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    document.removeEventListener('shopify:section:load', this.onSectionLoad);
  }

  onSectionLoad = (event) => {
    if (event.target.contains(this)) {
      this.observer?.disconnect();
      this.connectedCallback();
    }
  };

  loadSources() {
    if (this.loaded) return;
    this.sources.forEach((source) => {
      if (source.dataset.src) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      }
    });
    this.video.load();
    this.loaded = true;
  }
  }

  customElements.define('vt-lazy-video', VtLazyVideo);
}
